<template>
  <div class="small-modal modal">

    <div class="modal-main">

      <p class="modal-heading" v-if="$store.getters['modal/getHead1'] !== undefined && $store.getters['modal/getHead1'] !== ''">
        <span>{{ $store.getters['modal/getHead1'] }}</span>
      </p>

      <p class="modal-body">
        <span>{{ $store.getters['modal/getMessage1'] }}</span>
        <span v-if="$store.getters['modal/getMessage2'] !== undefined && $store.getters['modal/getMessage2'] !== ''">{{ $store.getters['modal/getMessage2'] }}</span>
        <span v-if="$store.getters['modal/getMessage3'] !== undefined && $store.getters['modal/getMessage3'] !== ''">{{ $store.getters['modal/getMessage3'] }}</span>
        <span v-if="$store.getters['modal/getMessage4'] !== undefined && $store.getters['modal/getMessage4'] !== ''">{{ $store.getters['modal/getMessage4'] }}</span>
      </p>

      <!--<a href="javascript:void(0)" class="close-modal" @click="closeElement()">-->
        <!--<span></span>-->
        <!--<span></span>-->
      <!--</a>-->
    </div>

  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import VueCookies from 'vue-cookies'
import Vue from 'vue'

Vue.use(VueCookies)
export default {
  name: 'util-modal',
  data () {
    return {
      utils: utils
    }
  },
  mixins: [utils]
}
</script>

<style lang="scss" scoped src="../scss/modal.scss"></style>



// WEBPACK FOOTER //
// src/components/modal/vue/UtilModal.vue